import React, { useEffect, useState } from "react";
import styles from "./item.module.css";
import { useDispatch, useSelector } from "react-redux";
import StarContainer from "../../components/star-container/star-container";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import ScrollUpButton from "../../components/buttons/scroll-up-button/scroll-up-button";
import FilterSelect from "../../components/filter-select/filter-select";
import SearchBox from "../../components/search-box/search-box";
import { setSortFilter, setTypeFilter } from "../../store/reducers/list/itemList";
import { selectFilteredItems, selectItemFilter } from "../../store/selectors/itemSelectors";
import { v4 } from "uuid";
import ItemDescModal from "../../components/item/item-desc-modal";
import getImageFileName from "../../functions/getImageFileName";
import { getUIText } from "../../translation";
import { LOCALES } from "../../constants";
import FILTERS from "../../config/filter_config.json";
import SORT_LIST from "../../config/sort_config.json";

export default function Item() {
    const theme = useSelector((state) => state.theme.value);
    const lang = useSelector((state) => state.lang.value);

    const itemFilter = useSelector(selectItemFilter);
    const [query, setQuery] = useState("");
    const filteredItems = useSelector((state) => selectFilteredItems(state, query));

    // const [FILTERS, setFILTERS] = useState(null);
    // const [SORT_LIST, setSORTLIST] = useState(null);

    // useEffect(() => {
    //     loadData("filter_config.json").then(setFILTERS);
    //     loadData("sort_config.json").then(setSORTLIST);
    // }, []);

    const [isActive, setIsActive] = useState(false);
    const [selected, setSelected] = useState(filteredItems[0]);

    const dispatch = useDispatch();

    const getRarityClassName = (rarity) => {
        return rarity.replace("IG_", "").toLowerCase();
    };

    // if (!FILTERS || !SORT_LIST) return;

    return (
        <div id="container" data-theme={theme} data-lang={lang}>
            {theme === "dark" && <StarContainer />}
            <Header title={getUIText(lang, "header.title.item")} />

            <div className={styles["items-container"]}>
                {/* filters */}
                <div className={styles["filters"]}>
                    <FilterSelect
                        id={"item_type"}
                        list={lang === LOCALES.KO ? FILTERS.ITEM_TYPE : FILTERS.ITEM_TYPE_ENG}
                        selected={itemFilter.type}
                        changeFilter={setTypeFilter}
                        forceWidth={"120px"}
                        key={v4()}
                    />
                    <FilterSelect
                        id={"item_sort"}
                        list={lang === LOCALES.KO ? SORT_LIST.ITEM_SORT : SORT_LIST.ITEM_SORT_ENG}
                        selected={itemFilter.sort}
                        changeFilter={setSortFilter}
                        forceWidth={"125px"}
                        key={v4()}
                    />
                </div>
                <SearchBox placeholder={getUIText(lang, "search.item")} changeQuery={setQuery} />

                {/* list */}
                <div className={styles["items"]}>
                    {filteredItems.map((item) => {
                        return (
                            <div
                                className={`${styles["item"]} ${styles[getRarityClassName(item.rarity)]}`}
                                key={v4()}
                                onClick={() => {
                                    setSelected(item);
                                    setIsActive(true);
                                }}
                            >
                                <img src={`${process.env.PUBLIC_URL}/images/item/${getImageFileName(item.name[LOCALES.KO])}.webp`} />
                                <span className={styles["item-name"]}>{item.name[lang]}</span>
                            </div>
                        );
                    })}
                </div>
            </div>

            <ItemDescModal lang={lang} selected={selected} isActive={isActive} setIsActive={setIsActive} />

            <ScrollUpButton />
            <Footer />
        </div>
    );
}
